<template>
  <div>
    <div class="content">
      <div class="content-main">
        <p class="content-title">角色权限<un-lock/><page-desc/></p>
        <div class="content-input">
          <div class="content-input-left">
            <div class="content-input-item">
              <label>角色类型</label>
              <el-select v-model="positionType" placeholder="Select" class="select-item" @change="positionTypeChange">
                <el-option v-for="item in positionTypeArray" :key="item.positionType" :label="item.name" :value="item.positionType">
                </el-option>
              </el-select>
            </div>
            <div class="content-input-item">
              <label>角色名称</label>
              <el-input v-model="name" placeholder="请输入角色名" style="margin-right: 16px;" clearable>
                <template #prefix>
                  <el-icon class="el-input__icon"><ElIcons name="search" /></el-icon>
                </template>
              </el-input>
            </div>
          </div>
          <div class="content-input-right">
            <div class="content-input-btn">
              <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
              <!--            <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>-->
            </div>
          </div>


        </div>
      </div>
      <div class="content-main" style="display: flex; flex-wrap: wrap;">
        <div class="add-card" @click="editRoleDialog(-1)">
          <ElIcons name="Plus" style="margin-bottom: 16px;" size="24"/>
          <span>添加角色名称</span>
        </div>
        <div v-for="(item,index) in pageDataList" :key="index" class="role-card">
          <div class="role-card-name"><ElIcons name="Avatar" style="margin-right: 4px;"/>{{item.name}}</div>
          <div class="role-card-data">
            <div class="role-card-data-item" @click="getUserList(item)"><p class="item-title">用户</p><p><span class="item-num">{{item.userCount}}</span>个</p></div>
            <div class="role-card-data-item" @click="getRoleMenuList(item)"><p class="item-title">权限</p><p><span class="item-num">{{item.menuCount}}</span>个</p></div>
          </div>
          <div class="role-card-btn">
            <el-link type="primary" class="btn-item" @click="editRoleDialog(index,item)">编辑</el-link>
            <el-link type="danger" class="btn-item" @click="delRole(item)">删除</el-link>
          </div>
        </div>
      </div>
      <div style="margin-right: 24px">
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getFormData, postFormData, deleteFormData } from "@/api/api";
import {getSysRolePageList, delSysRole, listFilterSysRole} from "@/api/url";
import UserRoleModelDialog from "./components/UserRoleModelDialog";
import Dialog from "@/assets/js/dialog"
import unLock from "@/layout/components/unLock";
import RoleUserListDialog from "@/views/setting/components/RoleUserListDialog";
import RoleMenuListDialog from "@/views/setting/components/RoleMenuListDialog";
// import BtnGroup from "@/components/BtnGroup";

export default {
  name: "SysRole",
  components: { unLock },
  data() {
    return {
      sysList: [],
      pageDataList: [],
      loading: false,
      checkColList: [],
      name: '',
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,

      positionTypeArray: [
        {name: '不限', positionType: -1},
      ],
      positionType: -1,

    }
  },
  methods: {

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.loading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['searchValue'] = this.name;
      param['positionType'] = this.positionType;
      // let positionTypes = []
      // this.positionTypeArray.map(item => {
      //   if(item.positionType != -1) {
      //     positionTypes.push(item.positionType)
      //   }
      // })
      // if(this.name) {
      //   param['positionTypes'] = positionTypes.toString();
      // }else {
      //   if(this.positionType == -1) {
      //     param['positionTypes'] = positionTypes.toString();
      //   }else {
      //     param['positionTypes'] = this.positionType;
      //   }
      // }
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getSysRolePageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.loading = false;
      })
          .catch((response) => {
            this.loading = false;
          })
    },
    /**
     * 格式化权限
     */
    formatList(list, preId) {
      let array = [];
      let _this = this;
      list.forEach(function(e) {
        if(e['preId'] == preId) {
          let children = _this.formatList(list, e['id']);
          if(children.length > 0) {
            e['children'] = children;
          }
          array.push(e);
        }
      });
      // console.log(array)
      return array;
    },

    editRoleDialog(idx,row) {
      let _title = '';
      let roleForm = {}
      if (idx > -1) {
        _title = '编辑角色'
        roleForm = Object.assign({}, row);
      }else {
        _title = '添加角色'
        roleForm = {
          id: 0,
          menuList: [],
          name: '',
          positionType: 1
        }
      }
      Dialog.open({
        title: _title,
        component: UserRoleModelDialog,
        data: {
          roleForm: roleForm,
          idx: idx,
          width: '800px'
        },
        confirm: (result) => {
              this.getPage()
        }
      })
    },

    delRole(data) {
      let _this = this;
      this.$confirm('确认删除角色【'+data.name+'】？', {
        type: 'warning'
      }).then(
          () => {
            postFormData(delSysRole, { id: data.id }).then (
                (result) => {
                  let code = result.code;
                  let msg = result.msg;
                  if(code == 200) {
                    this.getPage();
                  } else {
                    _this.$message({
                      showClose: true,
                      duration: 1000,
                      message: msg,
                      type: 'warning'
                    })
                  }
                }
            )
          }
      ).catch(() => {})
    },

    getSysRoleList() {
      getFormData(listFilterSysRole).then(data=> {
        if(data.code == 200) {
          this.sysRoleList = data.data
          this.sysRoleList.map(item => {
            let obj = {}
            obj.name = item.name
            obj.positionType = item.positionType
            this.positionTypeArray.push(obj)
          })
        }
      })
    },

    getUserList(item) {
      Dialog.open({
        title: '【' + item.name + '】绑定的用户',
        component: RoleUserListDialog,
        data: {
          id: item.id,
          width: '600px'
        },
      })
    },

    getRoleMenuList(item) {
      Dialog.open({
        title: '【' + item.name + '】角色的权限',
        component: RoleMenuListDialog,
        data: {
          menuList: item.menuList,
          width: '600px'
        },
      })
    },



  },
  mounted() {
    this.getSysRoleList()
    setTimeout(()=>{
      this.getPage();
    },500)

  }
}
</script>

<style scoped>
/*.el-table {*/
/*  --el-table-header-bg-color: #ffffff !important;*/
/*}*/

.role-card {
  border: 1px solid #ededed;
  width: 240px;
  height: 180px;
  margin: 0 16px 16px 0;
  border-radius: 12px;
  position: relative;
  overflow: hidden;
}

.add-card {
  border: 2px #ededed dashed;
  width: 240px;
  height: 180px;
  margin: 0 16px 16px 0;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #666666;
  cursor: pointer;
}

.add-card:hover {
  background-color: #f5f7fa;
}

.add-card-icon {
  font-size: 40px;
  line-height: 40px;
}

.role-card-name {
  display: flex;
  align-items: center;
  margin: 24px;
}

.role-card-data {
  display: flex;
  justify-content: space-around;
  margin: 0 40px 24px;
}

.role-card-data-item {
  display: flex;
  flex-direction: column;
  cursor: pointer;
}

.item-title {
  color: #aaaaaa;
  font-size: 12px;
  margin-bottom: 4px;
}

.item-num {
  font-size: 24px;
  font-weight: bold;
  margin-right: 4px;
}

.role-card-btn {
  background-color: #f5f7fa;
  /*padding: 8px 24px;*/
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: end;
  align-items: center;
}

.btn-item {
  margin-right: 24px;
}

</style>
